import { Typography } from "antd"
import SideMenu from "../../components/SideMenu/Index";
import '../index.css'

function Inventory() {
    return (<div className="abc">
        <div className="ab"><SideMenu/></div>
    <div className="ac">
        <Typography.Title level={4}>Hospital</Typography.Title>
    </div>
</div>
    );

}
export default Inventory